module.exports = __webpack_public_path__ + "img/xmasParty6.29223540.jpg";